import React from "react";

const Backdrop = ({ openBackdrop, component }) => {
  return (
    <>
      {openBackdrop && (
        <>
          <div className="fixed flex overflow-hidden items-center justify-center top-0 left-0 w-full h-screen z-20 opacity-60 bg-slate-400"></div>
          <div className="fixed overflow-hidden h-screen w-screen z-30 top-0 flex justify-center items-center">
            {component}
          </div>
        </>
      )}
    </>
  );
};

export default Backdrop;
